module.exports = __webpack_public_path__ + "031896e49030d99048ccd7804e13ff4c.png";